/**
 * Thin wrappers around the Meta (Facebook) Pixel `fbq` global.
 *
 * The base pixel snippet is loaded from `public/index.html`, which makes
 * `window.fbq` available across the SPA. These helpers guard against the
 * pixel being blocked (ad blockers, privacy extensions) or not yet loaded.
 */

function safeFbq(...args) {
  if (typeof window === 'undefined') return;
  if (typeof window.fbq !== 'function') return;
  try {
    window.fbq(...args);
  } catch (_err) {
    /* swallow — analytics must never break the app */
  }
}

export function trackEvent(eventName, params) {
  if (!eventName) return;
  if (params && Object.keys(params).length > 0) {
    safeFbq('track', eventName, params);
  } else {
    safeFbq('track', eventName);
  }
}

export function trackCustomEvent(eventName, params) {
  if (!eventName) return;
  if (params && Object.keys(params).length > 0) {
    safeFbq('trackCustom', eventName, params);
  } else {
    safeFbq('trackCustom', eventName);
  }
}

export function trackInitiateCheckout(params) {
  trackEvent('InitiateCheckout', params);
}

export function trackLead(params) {
  trackEvent('Lead', params);
}

export function trackPurchase(params) {
  trackEvent('Purchase', params);
}
